// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

// Material Kit 2 React examples
import HorizontalTeamCard from "examples/Cards/TeamCards/HorizontalTeamCard";

// Images
import team1 from "assets/images/T1.jpg";
import team2 from "assets/images/t2.jpg";
import team3 from "assets/images/t3.jpg";
import team4 from "assets/images/t4.jpg";
import team5 from "assets/images/t5.jpg";
import team6 from "assets/images/t6.jpg";

function Team() {
  return (
    <MKBox
      component="section"
      variant="gradient"
      bgColor="dark"
      position="relative"
      py={6}
      px={{ xs: 2, lg: 0 }}
      mx={-2}
    >
      <Container>
        <Grid container>
          <Grid item xs={12} md={8} sx={{ mb: 6 }}>
            <MKTypography variant="h3" color="white">
              Meet the Scuba Addicts Team...
            </MKTypography>
            <MKTypography variant="body2" color="white" opacity={0.8}>
              Passionate ocean lovers, skilled professionals, and friendly faces — ready to make
              every dive safe, fun, and unforgettable.
            </MKTypography>
          </Grid>
        </Grid>
        <Grid container spacing={3}>
          <Grid item xs={12} lg={6}>
            <MKBox mb={1}>
              <HorizontalTeamCard
                image={team1}
                name="Robbie"
                position={{ color: "info", label: "Instructor" }}
                description="Our certified dive instructor is your trusted guide to the underwater world. With years of experience, a passion for teaching, and a focus on safety, they make learning to dive both exciting and stress-free — whether it’s your first dive or your next certification."
              />
            </MKBox>
          </Grid>
          <Grid item xs={12} lg={6}>
            <MKBox mb={1}>
              <HorizontalTeamCard
                image={team2}
                name="Olivenzo"
                position={{ color: "info", label: "Dive Control Specialist (DCS)" }}
                description="Always ready with expert advice and a reassuring smile, our Dive Control Specialist supports every step of your journey — from planning your dive to ensuring smooth operations underwater. They help keep every adventure safe, organized, and unforgettable."
              />
            </MKBox>
          </Grid>
          <Grid item xs={12} lg={6}>
            <MKBox mb={{ xs: 1, lg: 0 }}>
              <HorizontalTeamCard
                image={team3}
                name="Tavin"
                position={{ color: "info", label: "Tour & Dive Master (TDM)" }}
                description="Your go-to for underwater exploration, our Tour & Dive Master knows every reef, wreck, and secret dive spot. They lead dives with skill, confidence, and a knack for spotting the ocean’s hidden treasures."
              />
            </MKBox>
          </Grid>
          <Grid item xs={12} lg={6}>
            <MKBox mb={{ xs: 1, lg: 0 }}>
              <HorizontalTeamCard
                image={team4}
                name="Nilanga"
                position={{ color: "info", label: "Boat Captain" }}
                description="Calm, capable, and always on course, our first boat captain ensures you reach every dive site safely and on time. With years of navigating Sri Lanka’s coastal waters, they make the journey as enjoyable as the destination."
              />
            </MKBox>
          </Grid>
          <Grid item xs={12} lg={6}>
            <MKBox mb={{ xs: 1, lg: 0 }}>
              <HorizontalTeamCard
                image={team5}
                name="Ravindra"
                position={{ color: "info", label: "Boat Captain" }}
                description="Equally experienced and friendly, our second boat captain knows the sea like the back of his hand. From smooth rides to quick pick-ups after your dive, he’s there to make your day on the water hassle-free and fun."
              />
            </MKBox>
          </Grid>
          <Grid item xs={12} lg={6}>
            <MKBox mb={{ xs: 1, lg: 0 }}>
              <HorizontalTeamCard
                image={team6}
                name="Randika"
                position={{ color: "info", label: "Dive center staff" }}
                description="Our warm and welcoming center staff are the heartbeat of our dive shop. From helping you gear up to sharing local tips, they make sure you feel at home from the moment you arrive until your last dive of the day."
              />
            </MKBox>
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default Team;
